module.exports = __webpack_public_path__ + "img/logo_tixify_dark.848c66e8.png";